var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.928 12.7472C19.928 8.07219 16.138 4.2832 11.464 4.2832C6.78899 4.2832 2.99902 8.07219 2.99902 12.7472C2.99902 17.4222 6.78899 21.2112 11.464 21.2112C16.138 21.2112 19.928 17.4222 19.928 12.7472Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0489 12.7471C16.0489 10.2141 13.9958 8.16211 11.4648 8.16211C8.93284 8.16211 6.87988 10.2141 6.87988 12.7471C6.87988 15.2781 8.93284 17.3311 11.4648 17.3311C13.9958 17.3311 16.0489 15.2781 16.0489 12.7471Z",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8871 5.46552L11.7271 12.6265M18.8871 5.46552H21.001M18.8871 5.46552V3.35352",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.4a291d22472309aae868c21ae85268db.svg";
export { ForwardRef as ReactComponent };